<script>
    import Item from './Item.svelte';
    import { onMount } from 'svelte';

    import { FirebaseApp, Doc, Collection } from 'sveltefire';
    
    import firebase from "firebase/app";
    import 'firebase/firestore';

    import queryString from 'query-string';

    export let currency;
    export let type;
    export let title;
    export let page = 0;
    export let url = '';
    
    /*
     * ds: DLC Sort
     * das: DLC After Sort
     * dbs: DLC Before Sort
     * di: DLC ID
     * dp: DLC Page
     * 
     * as: All Sort
     * aas: All After Sort
     * abs: All Before Sort
     * ai: All ID
     * ap: All Page
     * 
     * Is all of this necessary?
     * Yes.
     */

    let parsed = queryString.parse(url, {parseNumbers: true});

    let index = null;
    let games = [];
    let query, ref;
    let previousCount;
    let mouse = {x: 0, y: 0};
    let sort = 'title';
    let sort2 = '__name__';
    let order = false;

    let loading = true;

    switch(type) {
        case 'sale':
            query = (ref) => ref.where('end', '>', new Date(Date.now()));
            ref = firebase.firestore().collectionGroup('sales');
            break;
        case 'all':
            if(parsed['ap'] != null) page = parsed['ap'];
            if(parsed['as'] != null) sort = parsed['as'];
            if(parsed['aas'] != null && parsed['aas'].length > 0)
                query = (ref) => ref.where('playable', '==', true).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).startAfter(parsed['aas'], parsed['ai']).limit(15);
            else if(parsed['abs'] != null && parsed['abs'].length > 0)
                query = (ref) => ref.where('playable', '==', true).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).endBefore(parsed['abs'], parsed['ai']).limitToLast(15);
            else
                query = (ref) => ref.where('playable', '==', true).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).limit(15);
            ref = 'games';
            break;
        case 'addons':
            if(parsed['dp'] != null) page = parsed['dp'];
            if(parsed['ds'] != null) sort = parsed['ds'];
            if(parsed['das'] != null && parsed['das'].length > 0)
                query = (ref) => ref.where('playable', '==', null).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).startAfter(parsed['das'], parsed['di']).limit(15);
            else if(parsed['dbs'] != null && parsed['dbs'].length > 0)
                query = (ref) => ref.where('playable', '==', null).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).endBefore(parsed['dbs'], parsed['di']).limitToLast(15);
            else
                query = (ref) => ref.where('playable', '==', null).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).limit(15);
            ref = 'games';
            break;
        case 'pro':
            query = (ref) => ref.where('pro', '>', 0).limit(15);
            ref = 'games';
            break;
        case 'new':
            query = (ref) => ref.where('added', '>', new Date(new Date().setDate(new Date().getDate()-7))).orderBy('added', 'desc');
            ref = 'games';
            break;
    }

    function prevPage(first) {
        if(page <= 0) return;
        page -= 1;
        loading = true;
        switch(type) {
            case 'sale':
                query = (ref) => ref.where('end', '>', Date.now()).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).endBefore(first[sort], first.ref.id).limitToLast(15);
                break;
            case 'all':
                window.history.replaceState({}, null, queryString.stringifyUrl({url: window.location.href, query: {as: sort, aas: null, abs: first[sort], ai: first.ref.id, ap: page}}));
                query = (ref) => ref.where('playable', '==', true).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).endBefore(first[sort], first.ref.id).limitToLast(15);
                break;
            case 'addons':
                window.history.replaceState({}, null, queryString.stringifyUrl({url: window.location.href, query: {ds: sort, das: null, dbs: first[sort], di: first.ref.id, dp: page}}));
                query = (ref) => ref.where('playable', '==', null).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).endBefore(first[sort], first.ref.id).limitToLast(15);
        }
    }

    function nextPage(last) {
        if(previousCount < 15) return;
        page += 1;
        loading = true;
        console.log(last);
        switch(type) {
            case 'sale':
                query = (ref) => ref.where('end', '>', Date.now()).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).startAfter(last[sort], last.ref.id).limit(15);
                break;
            case 'all':
                window.history.replaceState({}, null, queryString.stringifyUrl({url: window.location.href, query: {as: sort, aas: last[sort], abs: null, ai: last.ref.id, ap: page}}));
                query = (ref) => ref.where('playable', '==', true).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).startAfter(last[sort], last.ref.id).limit(15);
                break;
            case 'addons':
                window.history.replaceState({}, null, queryString.stringifyUrl({url: window.location.href, query: {ds: sort, das: last[sort], dbs: null, di: last.ref.id, dp: page}}));
                query = (ref) => ref.where('playable', '==', null).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).startAfter(last[sort], last.ref.id).limit(15);
        }
    }

    function sortBy(method) {
        if(sort == method)
            order = !order;
        else order = false;
        page = 1;
        sort = method;
        switch(method) {
            case 'title':
                sort = 'title';
                break;
            case 'lrd':
                sort = 'prices';
            default:
                sort = 'title';
        }

        switch(type) {
            case 'sale':
                query = (ref) => ref.where('end', '>', new Date(Date.now()));
                ref = firebase.firestore().collectionGroup('sales');
                break;
            case 'all':
                query = (ref) => ref.where('playable', '==', true).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).limit(15);
                ref = 'games';
                break;
            case 'addons':
                query = (ref) => ref.where('playable', '==', null).orderBy(sort, order ? 'desc' : 'asc').orderBy(sort2).limit(15);
                ref = 'games';
                break;
        }
    }

</script>

<h2 style="{previousCount == 0 ? 'display: none !important' : ''}">{title}</h2>

<div style="{previousCount == 0 ? 'display: none !important' : ''}" class="cat">
    <table class="pure-table pure-table-horizontal pure-table-striped">
        <thead on:mousemove={e => mouse = {x: e.layerX-100, y: e.layerY+30}}>
            <tr>
                <th on:click={() => sortBy('title')}>Title</th>
                {#if type == 'sale'}
                    <th style="text-align: center" on:click={() => sortBy('lrd')}>Discount</th>
                {/if}
                <th style="text-align: end" on:click={() => sortBy('prices')}>Current Price</th>
                <th style="text-align: end" on:click={() => sortBy('lrd')} class="lrp">LRP
                <span style={"top: "+mouse.y+"px; left: "+mouse.x+"px;"}>Lowest Recorded Price</span></th>
                <th style="text-align: end">Game Link</th>
            </tr>
        </thead>
        <Collection idField={null} let:ref path={ref} {query} let:data let:first let:last on:data={(e) => {loading = false; if(e.detail.data != null) previousCount = e.detail.data.length; console.log(`previous: ${previousCount}`);}}> 
            <tbody>
                {#if type == 'sale'}
                    {#each data as sale}
                        {#if sale['discount'][currency.shorthand] != null || sale['discount'] > 0 }
                            <Doc let:traceId path={sale.ref.parent.parent} let:ref let:data={game}>
                                <Item type={'sale'} game={{
                                    id: game.id,
                                    type: game['type'],
                                    sku: ref.id,
                                    sale: true,
                                    price: game['prices'] ?? {'usd': 0, 'cad': 0, 'eur': 0, 'gbp': 0,
                                                              'sek': 0, 'dkk': 0, 'nok': 0, 'huf': 0,
                                                              'czk': 0, 'pln': 0},
                                    lrd: game['lrd'],
                                    title: game['title'],
                                    pro: game['pro'] != null ? game['pro'] : {},
                                    discount: sale['discount'],
                                    discountPro: sale['pro'] == true,
                                    free: game.free != null,
                                    playable: game.playable
                                }} {currency} />
                            </Doc>
                        {/if}
                    {/each}
                {:else}
                    {#each data as game}
                        <Collection path={game.ref.collection('sales')} query={(ref) => ref.where('end', '>', Date.now())} let:data={sales}>
                            {#if (type == 'new' && game.free) || type != 'new'}
                                    <Item game={{
                                        id: game.id,
                                        type: game['type'],
                                        sku: game.ref.id,
                                        sale: !sales.isEmpty,
                                        price: game['prices'] ?? {'usd': 0, 'cad': 0, 'eur': 0, 'gbp': 0,
                                                                'sek': 0, 'dkk': 0, 'nok': 0, 'huf': 0,
                                                                'czk': 0, 'pln': 0},
                                        lrd: game['lrd'] != null ? game['lrd'] : 0,
                                        title: game['title'],
                                        pro: game['pro'] != null ? game['pro'] : {},
                                        discount: sales.isNotEmpty ? sales.first['discount'] : 0,
                                        discountPro: sales.isNotEmpty ? sales.first['pro'] : false,
                                        free: game.free != null,
                                        playable: game.playable
                                    }} {currency} />
                            {:else if game.prices != null} <!-- Yeah, this is ugly and redundant. I know.-->
                                {#if game.prices[currency] != 0}
                                    <Item game={{
                                        id: game.id,
                                        type: game['type'],
                                        sku: game.ref.id,
                                        sale: !sales.isEmpty,
                                        price: game['prices'] ?? {'usd': 0, 'cad': 0, 'eur': 0, 'gbp': 0,
                                                                'sek': 0, 'dkk': 0, 'nok': 0, 'huf': 0,
                                                                'czk': 0, 'pln': 0},
                                        lrd: game['lrd'] != null ? game['lrd'] : 0,
                                        title: game['title'],
                                        pro: game['pro'] != null ? game['pro'] : {},
                                        discount: sales.isNotEmpty ? sales.first['discount'] : 0,
                                        discountPro: sales.isNotEmpty ? sales.first['pro'] : false,
                                        free: game.free != null,
                                        playable: game.playable
                                    }} {currency} />
                                {/if}
                            {/if}
                        </Collection>
                    {/each}
                {/if}
                {#if (previousCount >= 15 || page > 0) && type != 'sale' && type != 'new'}
                <tr class="load-more">
                    <td colspan="1" on:click={() => prevPage(first)}>
                        {loading ? 'Loading...' : '< Prev Page'}
                    </td>
                    {#if type == 'sale'}
                        <td></td>
                    {/if}
                    <td colspan="3" on:click={() => nextPage(last)} style="text-align: end">{loading ? '' : 'Next Page >'}</td>
                </tr>    
                {/if}        
            </tbody>
            <tbody slot="loading">
                {#each Array(previousCount) as _}
                <tr>
                    <td><b style="opacity: 0;">Title</b><br /><span style="opacity: 0;">Type</span></td>
                    <td></td>
                    {#if type == 'sale'}
                    <td></td>
                    {/if}
                    <td></td>
                    <td></td>
                </tr>
                {/each}
            </tbody>
            <tbody slot="fallback">
                {#each Array(previousCount) as _}
                <tr>
                    <td><b style="opacity: 0;">Title</b><br /><span style="opacity: 0;">Type</span></td>
                    <td></td>
                    {#if type == 'sale'}
                    <td></td>
                    {/if}
                    <td></td>
                    <td></td>
                </tr>
                {/each}
            </tbody>
        </Collection>
    </table>
</div>

<style>
    .cat {
        overflow-x: scroll;
        display: block;
    }

    :global(main.dark) .cat {
        color: #212121;
        filter: invert(1);
    }

    :global(.item:hover td) {
        background: #cbcbcb !important;
    }

    :global(main.dark) .cat .load-more td:hover {
        background: #cbcbcb !important;
    }

    .cat .load-more td:hover {
        background: #eeeeee;
        cursor: pointer;
    }

    .lrp span {
        visibility: hidden;
        width: 200px;
        background: #bbbbbb;
        color: #212121;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;
        position: absolute;
        z-index: 1;
    }

    .lrp:hover span {
        visibility: visible;
    }
</style>
